import type { Achievement } from "../achievement.types";
import { allMoves } from "../moveHistory";

export const comebackKidAchievement: Achievement = {
  id: "comebackKid",
  name: "Comeback Kid",
  icon: "backup-restore",
  description:
    "Won after being two or more moves further from the target than where you started.",
  isProgressive: true,
  // Remaining distance is the hops of the Local Optimal route, measured
  // against the gold path's hops (par). Every word
  // stood on counts: each move's start and landing, backtracked ones included.
  // Measured in remaining hops along the best remaining route.
  check: (gameReport, gameStatus) => {
    if (
      gameStatus !== "won" ||
      !gameReport ||
      !gameReport.optimalPath ||
      gameReport.optimalPath.length === 0
    ) {
      return false;
    }
    const startHops = gameReport.optimalPath.length - 1;
    return allMoves(gameReport).some((m) =>
      [m.hopsFromPlayerPositionToEnd, m.hopsFromChoiceToEnd].some(
        (h) => typeof h === "number" && h >= startHops + 2,
      ),
    );
  },
};
